import { deepValue, itemHasKey } from '@corratech/pylot-utils'
import { CartItemInterface, ProductInterface } from '@pylot-data/pylotschema'

export const MAX_CATEGORY_PATH_DEPTH = 5

export const formatCategoryPath = (
    path: string[] = [],
    appendItem?: string,
    maxDepth = MAX_CATEGORY_PATH_DEPTH
): string => {
    if (path.length === 0 || path[0] !== 'Home') {
        path.splice(0, 0, 'Home')
    }
    const lengthLimit = appendItem ? maxDepth - 1 : maxDepth
    path = path.slice(0, lengthLimit)
    if (appendItem) {
        path.push(appendItem)
    }
    return path.join('|')
}

const isCartItem = (
    item: CartItemInterface | ProductInterface
): item is CartItemInterface => {
    return itemHasKey(item, 'product')
}

// Get a longest breadcrumb path for a product
export const getCategoryPath = (
    data: CartItemInterface | ProductInterface,
    currentCategoryName?: string
): string => {
    let path: string[] = []
    const categories = isCartItem(data)
        ? deepValue(data, ['product', 'categories'])
        : deepValue(data, ['categories'])
    if (!Array.isArray(categories) || categories.length === 0) {
        return ''
    }
    categories.forEach((item) => {
        const breadcrumbs = deepValue(item, ['breadcrumbs'], [])
        if (!Array.isArray(breadcrumbs)) {
            return
        }
        const currentPath: string[] = []
        breadcrumbs.forEach((breadcrumb) => {
            const name = deepValue(breadcrumb, ['category_name'])
            if (name) {
                currentPath.push(name)
            }
        })
        // Use the last of the longest category paths
        if (currentPath.length >= path.length) {
            path = currentPath
        }
    })

    return formatCategoryPath(path, currentCategoryName)
}
